<script setup lang="ts">

import {ref} from 'vue';
import {createWorkspace} from "~/calls/workspace";

const loading = ref(false)
const workspaceName = ref<string | null>("")
const environmentName = ref<string | null>("")


const form = ref(null as any)
const formIsCompleted = ref(null)
const router = useRouter()

const onSubmit = async () => {
  const validation = await form.value.validate()
  if (!validation.valid) {
    return
  }
  loading.value = true
  createWorkspace(workspaceName.value!!, environmentName.value!!).then((r) => {
    if (!r.success) return
    router.push(`/workspace/${r.result.workspaceId}/env/${r.result.environmentId}/`)
  }).finally(() => {
    loading.value = false
  })
}
</script>

<template>
  <v-form v-model="formIsCompleted" ref="form" @submit.prevent="onSubmit">
    <v-text-field label="Workspace name"
                  hint="This will be the display name of the Workspace. Can be changed later."
                  v-model="workspaceName"
                  :rules="[formRules.required]"/>
    <v-text-field label="First environment name"
                  hint="This will be the display name of the first environment within the Workspace. Can be changed later."
                  :rules="[formRules.required]" counter maxlength="30" :readonly="loading"
                  class="mt-2"
                  v-model="environmentName"/>

    <div class="d-flex justify-end mt-2">
      <v-btn color="secondary" :loading="loading" :disabled="!formIsCompleted" type="submit">
        Create Workspace
      </v-btn>
    </div>
  </v-form>
</template>
